import React, { useState, useEffect, useRef } from 'react';
import Message from './Message.js'
import './Messaging.css'
import axios from 'axios'
import { Button } from 'semantic-ui-react'
import 'semantic-ui-css/semantic.min.css';
import moment from 'moment'
import 'moment/locale/fr'
import keypressSound from './../assets/keypress.wav'
import chainSound from './../assets/chain.mp3'
import suspenseSound from './../assets/suspense.wav'


//set moment to french
moment.locale('fr')



const Messaging = (props) => {

  const re = /\S/g;
  const [newMessage, setNewMessage] = useState('')
  const { messagesList, setMessagesList } = props
  const { contactList, setContactList, audioPlaying, setAudioPlaying, apiKey, validKey } = props
  const [endOfGame, setEndOfGame] = useState(false)

  let mobile = window.innerWidth < 900

  const scroll = useRef(null);

  const client = axios.create({
    headers: { 'Authorization': 'Bearer ' + apiKey }
  });


  useEffect(() => {
    client.current = axios.create({
      headers: { 'Authorization': 'Bearer ' + apiKey }
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validKey])

  const [context, setContext] = useState([])


  const suspenseWords = ['tueur',]

  // useEffect s'exécute quand l'une des variables de [messagesList, props.selectedContact, text] est modifiée
  // Quand on change de contact : changement du contexte et de l'historique, message input et loading réinitialisés
  useEffect(() => {
    scroll.current?.scrollIntoView({ behavior: "smooth", block: "end", inline: "start" })

    let newContext = []

    messagesList.find(contact => contact.nickname === props.selectedContact).messages.map(message => {
      if (message.author === 'system') {
        newContext.push({ "role": "system", "content": message.text })
      }
      else if (message.author === 'user') {
        newContext.push({ "role": "user", "content": message.text })
      } else {
        newContext.push({ "role": "assistant", "content": message.text })
      }
      return true
    })
    setContext(newContext)

  }, [contactList, messagesList, props.selectedContact], context)

  //Seulement quand on change de contact sélectionné, on scrolle en bas instantanément
  useEffect(() => {
    scroll.current?.scrollIntoView({ behavior: "instant", block: "end", inline: "start" })
  }, [props.selectedContact, contactList])

  const [waitingCharact, setWaitingCharacter] = useState([])

  const params = {
    "model": "gpt-3.5-turbo",
    "messages": context,
    "temperature": 0.7
  }

  //Appel de l'API
  const sendMessageToGPT = () => {
    client.post('https://api.openai.com/v1/chat/completions', params)
      .then(result => {
        console.log(result);
        addMessage(props.selectedContact, result.data.choices[0].message.content)
      }).catch(err => {
        console.log(err);
      }).finally(() => {
        setWaitingCharacter(waitingCharact.filter(contact => contact !== props.selectedContact))
      })
  }

  //count total number of messages in messagesList
  const countMessages = () => {
    let count = 0
    messagesList.map(contact => {
      count += contact.messages.length
      return true
    })
    return count
  }

  let key = 0;

  const addMessage = (author, newMessage) => {

    const currentDate = moment().format('ddd[, ]HH:mm')
    messagesList.find(contact => contact.nickname === props.selectedContact).messages.push({ text: newMessage, date: currentDate, author: author })

    //play suspense sound if message contains one of the 'suspense' words
    if (suspenseWords.some(word => newMessage.includes(word))) {
      const suspense = new Audio(suspenseSound);
      suspense.volume = 0.20;
      suspense.play();
    }
    setMessagesList([...messagesList])
  }


  function sendMessage() {
    //Si le message ne'est pas vide on le traite
    if (newMessage.match(re) && !endOfGame) {

      //add message
      addMessage("user", newMessage)
      //if true 
      if (messagesList.find(contact => contact.nickname === props.selectedContact).interactive === "Yes") {
        setWaitingCharacter([...waitingCharact, props.selectedContact])


        context.push({ content: newMessage, role: "user" })
        setContext(context)
        sendMessageToGPT()


        if (countMessages() > 100 && !contactList.find(contact => contact.name === 'Avocat')) {
          const newContact = { name: 'Avocat', number: '+393456543210' }
          contactList.push(newContact)
          //play chain sound 
          const chain = new Audio(chainSound);
          chain.volume = 0.10;
          chain.play();
        }
      }
      else if (messagesList.find(contact => contact.nickname === props.selectedContact).interactive === "End") {
        //detect if message contains only a string beginning with '+39'
        let nb = newMessage.match(/(?<!\+?\d\D*)(\+39\d{6,10}){1}(?=\D*)(?!\D*\+?\d)/g)
        console.log(nb)
        if (nb !== null) {
          console.log(nb[0])
          if (nb[0] === '+393387890123') addMessage("assistant", "Merci Carlo, nous avons vérifié son téléphone et trouvé des vidéos compromettantes. Nous nous occupons de te faire sortir. Bon travail, nous nous reverrons à Rome. ")
          else if (nb[0] === '+393496789012') addMessage("assistant", "Nous avons fouillé le téléphone lié à ce numéro mais la seule chose suspecte que nous ayons trouvé est qu’il avait prévu de se rendre à un restaurant nommé le « Mezzo » le soir du meurtre et qu’il ne l’a pas fait. Malheureusement, ça ne suffira pas à te faire sortir... Adieu Carlo.")
          else addMessage("assistant", "Nous n'avons rien trouvé dans son portable... Il est innocent Carlo... Adieu...")
          setEndOfGame(true)
        }

        else {
          setWaitingCharacter([...waitingCharact, props.selectedContact])

          context.push({ content: newMessage, role: "user" })
          setContext(context)
          sendMessageToGPT()
        }

      }
    } else if (newMessage.match(re) && endOfGame) {
      console.log(newMessage)
      const currentDate = moment().format('ddd[, ]HH:mm')
      messagesList.find(contact => contact.nickname === props.selectedContact).messages.push({ text: newMessage, date: currentDate, author: "user", gameEnded: true })
      setMessagesList([...messagesList])
    }
    setNewMessage('');
    contactList.find(contact => contact.name === props.selectedContact).currentMessage = ''
    setContactList(contactList)
  }

  //Appui sur entrée
  function clickPress(e) {
    if (e.keyCode === 13) {
      sendMessage()
    }
    //if keyCode between 49 and 90 or keycode 32 or 46 play assets/keypress.mp3
    else if ((e.keyCode >= 49 && e.keyCode <= 90) || e.keyCode === 32 || e.keyCode === 46) {
      const keypress = new Audio(keypressSound);
      keypress.volume = 0.10;
      keypress.play();
    }
  }

  function handleInput(e) {
    setNewMessage(e.target.value)
    contactList.find(contact => contact.name === props.selectedContact).currentMessage = e.target.value
    setContactList(contactList)
  }

  function handleSound() {
    setAudioPlaying(!audioPlaying)
  }

  return (
    <div className="messaging">
      <div className={mobile ? "messaging-title mobile" : "messaging-title"}>
        <div>{mobile ? props.selectedContact : "Conversation avec " + props.selectedContact}</div>
        <Button className="ui icon button volume-button" onClick={handleSound}>
          <i className={audioPlaying ? "volume up icon volume-icon" : "volume off icon volume-icon"}></i>
        </Button>
      </div>
      <div className="messages-container">
        <div className="messages-historic">
          {messagesList.find(contact => contact.nickname === props.selectedContact).messages.map(message => {
            key++
            if (message.author !== "system") {
              return <Message key={key} message={message} erreur={message?.gameEnded} date={message.date} author={message.author}>{message.text}</Message>
            } else {
              return null
            }
          })}
        </div>
        {waitingCharact.includes(props.selectedContact) && <div className="loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>}
        <div ref={scroll} className="scroll-offset"></div>

        <div className="send-box">
          <input className="message-input" type="text" placeholder="Envoyez un message..." onKeyDown={clickPress} value={newMessage} onChange={handleInput} />
          <Button className="ui icon blue button" onClick={sendMessage} color='blue'>
            <i className="send icon"></i>
          </Button>
        </div>
      </div>
    </div>
  );
}


export default Messaging
